import { HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfigGlobal } from '../../interfaces/globals/config-global.interfaces';

@Injectable()
export class Globals {
  readonly luqasWizardVersion: string;
  readonly appOrigin: string;
  readonly apiRoot: string;
  readonly server: string;
  readonly ubieAppUrl: string;
  readonly localStorageTokenName_luqas = 'currentUser_semsa';
  readonly localStorageTokenName_app = 'currentUser';
  private _isBeta$ = new BehaviorSubject<boolean>(false);
  private readonly _isBetaKey = 'isBeta';

  get isBeta$() {
    return this._isBeta$.asObservable();
  }

  get isBeta() {
    return this._isBeta$.value;
  }

  constructor(@Inject('config') config: ConfigGlobal) {
    this.appOrigin = config.appOrigin;
    this.apiRoot = config.apiRoot;
    this.server = config.server;
    this.ubieAppUrl = config.ubieAppUrl;
    this.luqasWizardVersion = config.luqasWizardVersion;
    this._setIsBetaFromStorage();
  }

  private _setIsBetaFromStorage() {
    const result = localStorage.getItem(this._isBetaKey);
    const isBeta = result === 'true' ? true : false;

    if (this.isBeta !== isBeta) {
      this._isBeta$.next(isBeta);
    }
  }

  setIsBeta(isBeta: boolean) {
    if (this.isBeta !== isBeta) {
      this._isBeta$.next(isBeta);
      localStorage.setItem(this._isBetaKey, isBeta.toString());
    }
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
}
